<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/IN92/IN92.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">IN 9.2 舱驾融合域控制器</div>
                <div class="detail-banner-desc">
                    IN9.2基于第五代平台 SA8797P；<br />
                    集成了多屏交互、3D 车模联动、智能生态应用、摄像头监控系统等功能；<br />
                    支持仪表、信息娱乐等功能；<br />
                    在高配版本中，还支持座舱与高级驾驶辅助系统（ADAS）的跨域融合，如泊车辅助（APA）、自动导航辅助驾驶（NOA）等。
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">产品说明</div>
                    <div class="detail-desc">
                        <div>
                            搭载高通第五代骁龙座舱智驾平台
                        </div>
                        <div>
                            单颗芯片支持多操作系统（Liunx/Android）
                        </div>
                        <div>
                            集成智能座舱、智能驾驶、电子后视镜于一体
                        </div>
                        <div>
                            最高支持12个显示屏、14路摄像头、6个模拟麦克风、104路麦克风阵列
                        </div>
                        <div>
                            4路百兆/2路千兆以太网, 9路CAN （FD），1路LIN
                        </div>
                        <div>
                            USB 3.1 x 2, WiFi 7, 蓝牙5.4
                        </div>
                        <div>
                            支持全栈手机互联：HiCar/ICCOA/Carplay/Android Auto
                        </div>
                        <div>
                            支持端侧大模型
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/IN92/IN92-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">3nm</div>
                                    <div class="k">制程</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">64GB+512GB</div>
                                    <div class="k">存储</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Up to 12</div>
                                    <div class="k">显示屏</div>
                                </div>

                                <div class="spec-item spec-item-last">
                                    <div class="v">CPU:660K DMIPS、GPU:8.1 TFLOPS</div>
                                    <div class="k">算力</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">1000 Base-T1 + 4*100 Base-T1</div>
                                    <div class="k">以太网</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Main BT: BT5.4、Vice BT: BT5.3 & BLE、WIFI6 & WIFI7</div>
                                    <div class="k">蓝牙WIFI</div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="spec-row">
                    
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">1000 Base-T1 + 4*100 Base-T1</div>
                                    <div class="k">以太网</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Main BT: BT5.4、Vice BT: BT5.3 & BLE、WIFI6 & WIFI7</div>
                                    <div class="k">蓝牙WIFI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/IN92/IN92-1.jpg" alt="200-1-02">
                    </div>
                </div> -->
                

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: 'IN 9.2 舱驾融合域控制器 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/IN92.html'
};

import { createApp } from 'vue';
import App from './IN92.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./IN92.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
